import {AManagerApi} from "@/classes/app/api/manager/a-manager-api";

export default class SiteTheme extends AManagerApi {
    protected _url: string = '/owner/site/theme';
}
